<template>
    <iframe class="simulation" ref="frame" :src="source" />
    <!-- :src="source" -->
</template>

<script>
    const target = process.env.NODE_ENV === 'production' ? 'https://learn.simcur.com' : 'http://localhost:8082';
    // const target = 'https://learn.simcur.com';

    export default {
        name: 'Simulation',
        data(){
            return {
                queue: [],
                loaded: false
            };
        },
        props: {
            root: Boolean
        },
        computed: {
            product(){
                return this.$store.getters.product;
            },
            source(){
                return `/simulations/${this.product.product_slug}.html`;
            }
        },
        methods: {
            execute(event){
                if(this.loaded){
                    if(this.$refs.frame){
                        this.$refs.frame.contentWindow.postMessage(event, target);
                    }else{
                        console.error('No simulation frame loaded!');
                    }
                }else{
                    this.queue.push(event);
                }
            }
        },
        mounted(){
            this.mounted = true;

            this.$refs.frame.addEventListener('load', () => {
                this.loaded = true;

                //Execute all of the queued items.
                while(this.queue.length){
                    this.execute(this.queue.shift());
                }
            });

            if(this.root){
                this.$store.subscribeAction(action => {
                    if(action.type === 'chapters/simulation'){
                        this.execute(action.payload);
                    }
                });
            }
        },
        destroyed(){
            this.loaded = false;
            this.mounted = false;
        }
    }
</script>

<style scoped lang="less">
    @import "~@/assets/less/variables";

    .simulation
    {
        width: 100%;
        height: 100%;
    }
</style>
